<template>
  <div class="f-search">
    <fn-form-field-input
      :id="`f-search-${name}`"
      v-model:value="model"
      :name="`f-search-${name}`"
      :placeholder="$t('filter.searchFilter', { name })"
      type="text"
      :action-icon="icon"
      :float-label="false"
      @input="emit('update:value', model)"
      @action-icon-click="clearSearch"
    />
  </div>
</template>

<script setup lang="ts">
defineProps({
  name: {
    type: String,
    required: true,
  },
});
const model = defineModel<string>();
const emit = defineEmits(['update:value']);

const searchIcon = {
  icon: 'magnifying-glass-bold',
  color: 'grey',
  size: 'xs',
};
const clearIcon = {
  icon: 'cross',
  color: 'grey',
  size: 'xs',
};
const icon = computed(() => {
  return !model.value ? searchIcon : clearIcon;
});
const clearSearch = () => {
  model.value = '';
  emit('update:value', '');
};
</script>

<style lang="scss" scoped>
.f-search {
  padding: 10px;
  border-bottom: 1px solid palette(grey, light);

  :deep(input) {
    background-color: palette(grey, lighter);
    border: 0;
    font-size: map-get($font-sizes, 'l');
    line-height: 26px;
  }
}
</style>
